import React, { useState, useEffect } from 'react';
import { THEME } from '../../utils/theme';
import api from '../../utils/api';
import Spinner from '../ui/Spinner';
import Badge from '../ui/Badge';

const RecentlyAddedModal = ({ onClose, onShowDetail }) => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/games/recently-added?days=7').then(data => {
      setGames(data.games || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(5,5,10,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(20px) saturate(180%)', WebkitBackdropFilter: 'blur(20px) saturate(180%)' }} onClick={onClose}>
      <div style={{ background: `linear-gradient(145deg, ${THEME.bgElevated}, ${THEME.bgCard})`, borderRadius: '20px', padding: '24px', width: '95%', maxWidth: '500px', maxHeight: '85vh', overflow: 'auto', border: `1px solid ${THEME.border}`, boxShadow: `0 25px 80px ${THEME.shadowHeavy}`, animation: 'scaleIn 0.2s ease' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: THEME.text, fontSize: '20px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '24px' }}>✨</span> Recently Added
          </h2>
          <button onClick={onClose} style={{ background: THEME.bgHover, border: 'none', borderRadius: '8px', padding: '8px 12px', color: THEME.textMuted, cursor: 'pointer' }}>✕</button>
        </div>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Spinner /></div>
        ) : games.length === 0 ? (
          <div style={{ textAlign: 'center', color: THEME.textMuted, padding: '40px' }}>No new games added in the last 7 days</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {games.map(game => (
              <div key={game.id} onClick={() => { onShowDetail(game); onClose(); }} style={{ display: 'flex', gap: '12px', alignItems: 'center', padding: '10px', background: THEME.bg, borderRadius: '10px', cursor: 'pointer', border: `1px solid ${THEME.border}` }}>
                <img src={game.header_image} alt="" style={{ width: '70px', height: '40px', objectFit: 'cover', borderRadius: '6px' }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: THEME.text, fontWeight: '600', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{game.name}</div>
                  <div style={{ color: THEME.textMuted, fontSize: '11px' }}>{game.multiplayer_type || 'Multiplayer'}</div>
                </div>
                <Badge color={THEME.success} bg={`${THEME.success}20`}>NEW</Badge>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentlyAddedModal;
